import lozad from "lozad";

const observer = lozad(".lozad", {
  rootMargin: "125px 0px",
});

export const observeLazyImages = () => {
  observer.observe();
};

(() => {
  window.addEventListener("load", () => {
    observeLazyImages();
  });
})();
